import { render, staticRenderFns } from "./CompanyUserPermissionCreateModal.vue?vue&type=template&id=8754ee42&"
import script from "./CompanyUserPermissionCreateModal.vue?vue&type=script&lang=js&"
export * from "./CompanyUserPermissionCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports